import { useContext } from 'react';

import { ILayoutContext, LayoutContext } from 'utils/context/LayoutContext';

export const useLayout = () => {
  const layout = useContext(LayoutContext);
  if (!layout) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return layout as ILayoutContext;
};
